import SEO from "@/components/site/SEO";
import Stats from "@/components/sections/Stats";
import CTA from "@/components/sections/CTA";

export default function About() {
  return (
    <div data-testid="page-about">
      <SEO title="About" description="SECQRE is a privacy-first contact layer for parked vehicles. Made by drivers, for drivers." path="/about" />

      <section className="pt-32 md:pt-40 pb-12">
        <div className="container-secqre grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <span className="overline">— About SECQRE</span>
            <h1 className="mt-4 font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tight" data-testid="about-title">
              We make tech, <br />for privacy.
            </h1>
            <p className="mt-7 text-lg md:text-xl text-[#475569] max-w-2xl leading-relaxed">
              SECQRE is the US chapter of a story that started in 2019, when our founders watched a friend
              get harassed for weeks after leaving a phone number on a windshield. We built the first
              version that weekend. Six years and 950,000 drivers later, we&apos;re bringing the same
              engineering, the same obsession with masked calls, and the same one-time pricing to America.
            </p>
          </div>
          <div className="lg:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_tech-secqre/artifacts/ynm0rquj_WhatsApp%20Image%202026-05-18%20at%207.57.37%20PM.jpeg"
              alt="SECQRE mobile dashboard"
              className="w-full rounded-2xl border border-[#E2E8F0]"
              data-testid="about-image"
            />
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container-secqre grid md:grid-cols-3 gap-6">
          <Value n="01" title="Privacy is non-negotiable" body="Your phone number never leaves our infrastructure. Period." />
          <Value n="02" title="Hardware should be invisible" body="A great sticker disappears into your windshield. The tech disappears into your day." />
          <Value n="03" title="Honest pricing only" body="Buy once. No subscriptions. Refunds within 60 days, no questions." />
        </div>
      </section>

      <Stats />
      <CTA />
    </div>
  );
}

function Value({ n, title, body }) {
  return (
    <div className="rounded-2xl border border-[#E2E8F0] bg-white p-8" data-testid={`value-${n}`}>
      <div className="font-mono text-xs text-[#FFD600] font-bold tracking-widest">{n}</div>
      <h3 className="mt-4 font-heading font-bold text-2xl">{title}</h3>
      <p className="mt-3 text-[#475569] leading-relaxed">{body}</p>
    </div>
  );
}
